export default (align) => {
  switch (align) {
    case 'bottom':
      return {
        alignItems: 'flex-end',
        justifyContent: 'center',
      };
    case 'bottomRight':
      return {
        alignItems: 'flex-end',
        justifyContent: 'flex-end',
      };
    case 'bottomLeft':
      return {
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
      };
    case 'left':
      return {
        alignItems: 'center',
        justifyContent: 'flex-start',
      };
    case 'right':
      return {
        alignItems: 'center',
        justifyContent: 'flex-end',
      };
    case 'center':
      return {
        alignItems: 'center',
        justifyContent: 'center',
      };
    case 'topLeft':
      return {
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      };
    case 'topRight':
      return {
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
      };
    case 'top':
    default:
      return {
        alignItems: 'flex-start',
        justifyContent: 'center',
      };
  }
};
